<template>
  <div class="do-scheduler-sort">
    <DDropdown :isShowDots="false"
               :propOffset="[0, 8]"
               :isCloseOnDropdownClick="false">
      <button class="do-bttn do-bttn__filter" slot="title">
        <span class="icon-shuffle2"></span>
        {{ i18n['sort_by'] }}
      </button>
      <ul slot="list" class="do-filters__filter__dropdown">
        <li class="do-filters__filter__dropdown__item do-filters__filter__dropdown__item--group-top" @click.stop.prevent>
          <h5>{{ i18n['group_at_top'] }}</h5>
          <DoFiltersFilter
            :title="''"
            :placeholder="i18n['group_placeholder']"
            :tags="groupTags"
            :selectedTags="selectedGroupTags"
            :numberOfSelectedTagsToShow="1"
            @select="toggleGroupTag"
            @clear="clearAllGroupTags">
          </DoFiltersFilter>
        </li>
        <li v-for="option in options"
            :key="option.value"
            @click="select(option.value)"
            class="do-filters__filter__dropdown__item"
            :class="{'do-filters__filter__dropdown__item--selected': option.selected}">
          {{ option.name }}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-check"><circle cx="12" cy="12" r="10" class="primary"></circle> <path d="M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z" class="secondary"></path></svg>
        </li>
      </ul>
    </DDropdown>
  </div>
</template>

<script>
import DDropdown from '../../common/DDropdown.vue'
import DoFiltersFilter from '../../DoFilters/DoFiltersFilter.vue'

const I18N = {
  da: {
    name: 'Navn',
    pools: 'Vikarpulje (høj til lav)',
    poolsAsc: 'Vikarpulje (lav til høj)',
    workHours: 'Arbejdstid',
    proposals: 'Forslag',
    sort_by: 'Sortering af vikarer',
    group_at_top: 'Vælg en gruppe øverst',
    group_placeholder: 'Vælg gruppe'
  },
  nb: {
    name: 'Navn',
    pools: 'Vikarpulje (høy til lav)',
    poolsAsc: 'Vikarpulje (lav til høy)',
    workHours: 'Arbeidstid',
    proposals: 'Suggestions',
    sort_by: 'Sorter vikarer',
    group_at_top: 'Velg en gruppe øverst',
    group_placeholder: 'Velg gruppe'
  },
  en: {
    name: 'Name',
    pools: 'Substitute pool (high to low)',
    poolsAsc: 'Substitute pool (low to high)',
    workHours: 'Work hours',
    proposals: 'Forslag',
    sort_by: 'Sort substitutes by',
    group_at_top: 'Select a group at top',
    group_placeholder: 'Select group'
  }
}

export default {
  components: {DDropdown, DoFiltersFilter},
  props: {
    selected: {
      default: 'name'
    },
    locale: {
      default: 'da'
    },
    groupTags: {
      type: Array,
      default: () => []
    },
    selectedGroupTags: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    i18n () {
      return I18N[this.locale]
    },
    selectedI18n () {
      const selectedOptions = this.options.find(option => option.value === this.selected)
      return selectedOptions.name || ''
    },
    options () {
      return [
        {value: 'subzen', name: this.i18n['proposals'], selected: this.selected === 'subzen'},
        {value: 'name', name: this.i18n['name'], selected: this.selected === 'name'},
        {value: 'pools', name: this.i18n['pools'], selected: this.selected === 'pools'},
        {value: 'poolsAsc', name: this.i18n['poolsAsc'], selected: this.selected === 'poolsAsc'},
        {value: 'workHours', name: this.i18n['workHours'], selected: this.selected === 'workHours'}
      ]
    }
  },
  methods: {
    select (selected) {
      this.$emit('onSortBy', selected)
    },
    toggleGroupTag (tag) {
      this.$emit('toggleGroupTag', tag)
    },
    clearAllGroupTags () {
      this.$emit('clearAllGroupTags')
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";
.tw-icon {
  width: 1.5rem;
}

.tw-icon .primary {
  fill: transparent;
}

.do-filters__filter__dropdown__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem
}

.do-filters__filter__dropdown__item > .tw-icon {
  opacity: 0;
}

.do-filters__filter__dropdown__item--selected {
  color: var(--purple);
}

.do-filters__filter__dropdown__item--selected > .tw-icon {
  opacity: 1;
}

.do-filters__filter__dropdown__item--selected > .tw-icon .secondary {
  fill: var(--purple);
}

.do-filters__filter__dropdown__item--group-top {
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  padding-bottom: 0.75rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #e4e4e7;
}

.do-filters__filter__dropdown__item--group-top h5 {
  margin: 0;
  font-size: 0.85rem;
  color: #6c7a87;
}
</style>



// WEBPACK FOOTER //
// SchedulerSort.vue?3bbf8fa2